<!-- Card -->
<div
  id="UserComponent"
  class="card esri-widget animation-on-tool-open"
  gisDraggableWidget
  [dragHandle]="dragArea"
  [hidden]="hiddenContainer"
  #userComponentRef
>
  <!--- Card Header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-9" translate>
        WIDGET.USER.PANEL_HEADING
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>
  <!-- the panel body -->
  <div class="card-body">
    <dl class="row">
      <dt class="col-sm-3 text-right">User</dt>
      <dd class="col-sm-9">{{ user?.userId }}</dd>
      <dt class="col-sm-3 text-right">Rolle / rôle / ruolo</dt>
      <dd class="col-sm-9">
        <span *ngFor="let role of user?.roles">
          {{ role }}<br/>
        </span>
      </dd>
    </dl>
    <div class="row">
      <button class="btn btn-primary btn-block btn-sm" (click)="logout()" translate>
        COMMON.LOGOUT
      </button>
    </div>
  </div>
</div>
